import { Link, Outlet, useLoaderData } from "@remix-run/react"
import { useEffect, useState } from "react"

import Autoplay from "embla-carousel-autoplay"
import {
  action,
  loader,
} from "~/.server/route-container/authentication/sign-up"
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from "~/components/ui/carousel"
import { SignupProvider } from "~/hooks/SignupContext"

export { action, loader }

// export const meta: MetaFunction = () => {
//   return [
//     { title: `${APP_META_TITLE} - Нэвтрэх` },
//     { name: "description", content: "нэвтрэх, хэрэглэгчийн нэвтрэх" },
//     { name: "keywords", content: "нэвтрэх, хэрэглэгчийн нэвтрэх" },
//     { name: "robots", content: "index, follow" },
//     { property: "og:locale", content: "mn_MN" },
//     { property: "og:site_name", content: "nomin.mn" },
//     { tagName: "link", rel: "canonical", href: `https://nomin.mn/sign-in` },
//   ]
// }

export default function SignUpPage() {
  const { banners } = useLoaderData() as { banners: any }
  const [api, setApi] = useState<CarouselApi>()
  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    if (!api) return

    const updateActiveIndex = () => {
      setActiveIndex(api.selectedScrollSnap())
    }

    api.on("select", updateActiveIndex)
  }, [api, activeIndex])

  const hasBanners = Array.isArray(banners) && banners.length > 0

  return (
    <SignupProvider>
      <div
        className={`flex items-center gap-20 ${
          hasBanners ? "md:justify-between justify-center" : "justify-center"
        }`}
      >
        {/* {hasBanners && (
          <div className="items-center justify-center hidden md:flex">
            <div className="relative max-w-[800px] mx-auto">
              <Carousel
                opts={{
                  align: "start",
                  loop: true,
                }}
                setApi={setApi}
                plugins={[Autoplay({ delay: 6000 })]}
              >
                <CarouselContent>
                  {banners?.length > 0 &&
                    (banners || []).map((banner: any, index: number) => (
                      <CarouselItem key={index} className="w-full h-auto">
                        <Link to={banner?.url || ""}>
                          <img
                            src={banner?.asset?.preview}
                            alt="asdas"
                            className="w-[800px] h-[800px] object-contain rounded-lg"
                          />
                        </Link>
                      </CarouselItem>
                    ))}
                </CarouselContent>
              </Carousel>
              <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
                {banners?.map((_: any, index: number) => (
                  <button
                    key={index}
                    className={`w-1 h-1 rounded-full sm:w-3 sm:h-3 ${
                      index === activeIndex ? "bg-primary" : "bg-gray-300"
                    }`}
                    onClick={() => api?.scrollTo(index)}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        )} */}
        <div
          className={hasBanners ? "w-full max-w-md" : "w-full max-w-md mx-auto"}
        >
          <Outlet />
        </div>
      </div>
    </SignupProvider>
  )
}
